var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popup',{ref:"popupRefs",attrs:{"async":true,"width":"700px","title":"查看线索","confirm-button":false,"cancel-button":"关闭"},on:{"close":_vm.onClose}},[_c('div',_vm._l((_vm.form.content),function(value,key){return _c('div',{key:key,staticStyle:{"margin-bottom":"10px"}},[_c('strong',[_vm._v(_vm._s(key)+"：")]),_vm._v(" "+_vm._s(value)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }